@if (model$ | async; as model) {
  @if (introImage.type === imagesTypes.IMAGE) {
    <div
      class="container-intro-cover"
      [ngStyle]="{ 'background-image': 'url(' + introImage.src + ')', 'background-color': 'var(--dark-custom)' }"></div>
  }
  @if (introImage.type === imagesTypes.LOTTIE) {
    <div class="lottie-intro-box">
      <div class="lottie-hallo"></div>
      <shared-lottie [jsonPath]="introImage.src" [speed]="0.5" class="plante"></shared-lottie>
    </div>
  }
  <div class="container-intro">
    <div class="intro-top">
      @if (model.params.styleParams.logoImage) {
        <img
          class="intro-logo"
          [src]="model.params.styleParams.logoImage.src"
          [alt]="model.params.styleParams.logoImage.alt"
          [title]="model.params.styleParams.logoImage.alt" />
      }
      <h1 [innerHTML]="model.context.title" class="intro-title"></h1>
      @if (model.context.objectives) {
        <p class="intro-objectives" [innerHTML]="model.context.objectives | safeHtml"></p>
      }
      <div class="intro-info">
        @if (!model.params.hideLandingFormationTime) {
          @if (model.chapters.length > 1) {
            <div class="intro-item intro-info-chapters">
              <div class="intro-item-inner">
                <div class="number">{{ model.chapters.length }}</div>
                <div class="label" [innerHTML]="'learniz.landing-page.nb-chapter' | wording"></div>
              </div>
            </div>
          }
          <div class="intro-item intro-info-duration" [class.align-center]="model.chapters.length < 2">
            <div class="intro-item-inner">
              <div class="number">
                {{
                  getTotalRecommendedDuration(model.chapters)
                    | time: '{h} ' + ('learniz.landing-page.unity' | wording) + ' {min}'
                }}
              </div>
              <div class="label" [innerHTML]="'learniz.landing-page.duration' | wording"></div>
            </div>
          </div>
        }
      </div>
      @if (model.context.author) {
        <div class="intro-author">
          <div class="intro-author-title" [innerHTML]="'learniz.landing-page.author' | wording"></div>
          <div class="intro-author-content" [innerHTML]="model.context.author"></div>
        </div>
      }
    </div>
    <div class="intro-bottom">
      <button class="btn-scroll-down" (click)="goDown.next()">
        <span [innerHTML]="'learniz.scroll.down' | wording"></span>
        <span class="icon icon-learniz-angle-down"></span>
      </button>
    </div>
  </div>
}
